import { render, staticRenderFns } from "./diagnosisReportDownload.vue?vue&type=template&id=2df37db2&scoped=true&"
import script from "./diagnosisReportDownload.vue?vue&type=script&lang=js&"
export * from "./diagnosisReportDownload.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisReportDownload.vue?vue&type=style&index=0&id=2df37db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df37db2",
  null
  
)

export default component.exports